const events = require('../core/events');
const forgeUiComponent = require('../framework/ui-component');

const SUCCESS_URL = 'https://aw.bff.fm/html/donation-success.html';
const WINDOW_WIDTH = 780;
const CORE_POPUP_OPTIONS = [
  'resizable',
  'width=' + WINDOW_WIDTH,
  'height=640',
  'alwaysRaised'
];

const URL_FIELD = 'custom1';
const SHOW_DESIGNATION_FIELD = 'custom2';
const DJ_DESIGNATION_FIELD = 'custom3';

const KindfulDonation = forgeUiComponent('KindfulDonation', {
  customAmount: 'is-customAmount'
}, function KindfulDonationConstructor() {
  const self = this;

  const amountFieldset = this.element.querySelector('.KindfulDonation-amount') || document.createElement('div');
  const otherAmountInput = this.element.querySelector('.KindfulDonation-customAmount') || document.createElement('input');
  const otherAmountRadio = this.element.querySelector('.KindfulDonation-customDonationRadio') || document.createElement('input');
  const initalRadio = this.element.querySelectorAll('input[name="cart[items][0][amount]"]')[1] || document.createElement('input');
  const recurringCheckbox = this.element.querySelector('input[name=schedule]') || document.createElement('input');
  var currentCampaignId = (this.element.querySelector('input[name=campaign_id]') && this.element.querySelector('input[name=campaign_id]').value) || 0

  Object.defineProperty(this, 'showDesignation', {
    get: function getDesignation() {
      const mainContent = document.querySelector('main');
      const mainDesignation = mainContent && mainContent.getAttribute('data-donation-show-designation');
      return mainDesignation || this.element.getAttribute('data-show-designation');
    }
  });

  Object.defineProperty(this, 'djDesignation', {
    get: function getDesignation() {
      const mainContent = document.querySelector('main');
      const mainDesignation = mainContent && mainContent.getAttribute('data-donation-dj-designation');
      return mainDesignation || this.element.getAttribute('data-dj-designation');
    }
  });

  Object.defineProperty(this, 'donationProductId', {
    get: function getDesignation() {
      const mainContent = document.querySelector('main');
      const mainDonationId = mainContent && mainContent.getAttribute('data-donation-id');
      return mainDonationId || this.element.getAttribute('data-id');
    }
  });

  Object.defineProperty(this, 'wantsRecurringDonation', {
    get: function getRecurring() {
      return !!this.element.querySelector('input[name=schedule]:checked');
    }
  });

  Object.defineProperty(this, 'donationAmount', {
    get: function getDonationAmount() {
      const selectedRadio = this.element.querySelector('input[name="cart[items][0][amount]"]:checked');
      // Event handler below ensures that otherAmountInput.value is cleared if a preset radio is checked.
      return otherAmountInput.value || selectedRadio.value;
    }
  });

  Object.defineProperty(this, 'baseUrl', {
    get: function getBaseUrl() {
      // By adding this hash, you can skip the Kindful flow and
      // clicking donate will skip through the 'success' state.
      if (document.location.hash === '#__donation-test') {
        return SUCCESS_URL;
      }
      return this.element.action;
    }
  });

  Object.defineProperty(this, 'campaignId', {
    get: function getCampaignId() {
      return currentCampaignId;
    },
    set: function setCampaignId(newId) {
      if (!newId || isNaN(newId)) {
        currentCampaignId = (this.element.querySelector('input[name=campaign_id]') && this.element.querySelector('input[name=campaign_id]').value) || 0;
      } else {
        currentCampaignId = newId;
      }
    }
  });

  document.addEventListener(events.uiWantsDonation, function (e) {
    // Uncheck “Make recurring” unless special URL used
    recurringCheckbox.checked = (document.location.hash === '#monthly-support');
    initalRadio.checked = true;
    self.customAmount = false;

    if (otherAmountInput.value > 0) {
      otherAmountInput.required = false;
      otherAmountInput.value = '';
    }

    // set the campaign ID
    self.campaignId = e.detail && e.detail.campaign;
  }, false);

  window.addEventListener('message', function (ev) {
    if (ev.data === 'kindful-donation-complete') {
      self.element.dispatchEvent(new CustomEvent(events.uiModalDismiss, { bubbles: true }));
    }
  }, false);

  this.element.addEventListener('submit', function (ev) {
    ev.preventDefault();

    const amount = self.donationAmount;

    if (amount > 0) {
      const url = self.buildPopupUrl(amount);
      self.element.dispatchEvent(new CustomEvent(events.donationStarted, {
        bubbles: true,
        detail: {
          amount: amount
        }
      }));

      self.popupKindful(url);
    } else {
      /* eslint-disable no-alert */
      window.alert('Please choose or enter an amount to donate. Thank you!');
      /* eslint-enable no-alert */
    }
  });

  // Handle entering custom amounts vs. radio buttons
  // If the custom input has a value set, then set the component class, and shift
  // radio focus to the hidden “custom amount” radio.
  // If a radio is hit, clear the value of the custom field and unset the component class.
  amountFieldset.addEventListener('change', function listenForRadioChange(ev) {
    if (!ev.target) return;

    if (ev.target === otherAmountInput && ev.target.value > 0) {
      self.customAmount = true;
      otherAmountRadio.checked = true;
      otherAmountInput.required = true;
    } else if (ev.target !== otherAmountRadio) {
      self.customAmount = false;
      otherAmountInput.required = false;
      otherAmountInput.value = '';
    }
  }, false);

  otherAmountInput.addEventListener('keydown', function listenForAmountKeyPress() {
    if (!self.customAmount) {
      self.customAmount = true;
      otherAmountRadio.checked = true;
      otherAmountInput.required = true;
    }
  });
});

KindfulDonation.prototype.buildPopupUrl = function makePopupUrl(amount) {
  var params = {
    campaign_id: this.campaignId,
    'cart[desc]': 'Donation to BFF.fm',
    custom_answers: 'true'
  };

  params['cart[items][0][amount]'] = amount;
  params['cart[items][0][quantity]'] = '1';

  if (this.showDesignation) {
    params['cart[items][0][desc]'] = 'BFF.fm Donation (supporting ' + this.showDesignation + ')';
  } else if (this.djDesignation) {
    params['cart[items][0][desc]'] = 'BFF.fm Donation (via DJ ' + this.djDesignation + ')';
  } else {
    params['cart[items][0][desc]'] = 'BFF.fm Donation';
  }

  if (this.donationProductId) {
    params['cart[items][0][product_id]'] = this.donationProductId;
  } else {
    params['cart[items][0][product_id]'] = 'default-donation';
  }

  if (this.wantsRecurringDonation) {
    params.schedule = '1';
    params.bill_today = 'true';
  }

  if (this.showDesignation) {
    params[SHOW_DESIGNATION_FIELD] = this.showDesignation;
  } else if (this.djDesignation) {
    params[DJ_DESIGNATION_FIELD] = this.djDesignation;
  }

  params[URL_FIELD] = document.location.href;
  params.success_url = SUCCESS_URL;
  params.success_action = 'GET';

  const serializedParams = Object.keys(params).map(function (k) {
    return [k, encodeURIComponent(params[k])].join('=');
  }).join('&');

  return [this.baseUrl, serializedParams].join('?');
};

KindfulDonation.prototype.popupKindful = function popupKindfulFlow(url) {
  const self = this;
  const posX = ((window.outerWidth / 2) + window.screenX) - Math.floor(WINDOW_WIDTH / 2);
  const posY = window.screenY + 40;

  const finalFeatures = CORE_POPUP_OPTIONS.concat([
    'left=' + posX,
    'top=' + posY
  ]).join(',');

  const popup = window.open(url, '_blank', finalFeatures);

  const listenForClose = window.setInterval(function isPopupClosed() {
    if (popup.closed) {
      window.clearInterval(listenForClose);
      self.element.dispatchEvent(new CustomEvent(events.donationEnded, { bubbles: true }));
      self.element.dispatchEvent(new CustomEvent(events.uiModalDismiss, { bubbles: true }));
    }
  }, 500);
};

module.exports = KindfulDonation;



//////////////////
// WEBPACK FOOTER
// ./src/js/ui/kindful-donation.js
// module id = 65
// module chunks = 0